var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"py-2 px-3 rounded",attrs:{"id":"drag-ghost"}},[_c(_setup.FontAwesomeIcon,{staticClass:"mr-1",attrs:{"icon":"paper-plane"}}),_vm._v(" "),_c(_setup.TextShort,{staticClass:"font-weight-bold",attrs:{"text":_setup.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }